import cacheService from '../../../services/cacheService';
import { addEntityToPathway } from './addEntityToPathway';
import uuid from '../../../services/uuid';

type Response = {
  step: { id: string };
};

export const addCoursesToPathway = (
  pathwayId: string,
  courseIds: string | string[],
  previousId: string,
  nextId: string,
  initiatingUserId: string
): Promise<Response> => {
  cacheService.remove(`/v1/workflows/${pathwayId}`);

  const steps = (Array.isArray(courseIds) ? courseIds : [courseIds]).map(id => ({
    id: uuid.generate(),
    taskListId: { id },
    _type: 'TaskList',
  }));

  return steps
    .reduce((promise, step, index) => {
      const previous = index === 0 ? previousId : steps[index - 1]?.id;

      return promise.then(() =>
        addEntityToPathway(
          pathwayId,
          {
            step,
            previous,
            next: nextId,
          },
          initiatingUserId
        )
      );
    }, Promise.resolve())
    .then(data => data as unknown as Response);
};
